<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="ADVANCED" src="assets/img/ph_lesson16.jpg"><span>ADVANCED</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson01.png">
                <p>中・上級者向けのプログラムです。長めのマインドフルネス瞑想を行いますが、初めての方もぜひチャレンジしてみてください。難しければいつでも退出可能です。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="SILENT" src="assets/img/ph_lesson14.jpg"><span>SILENT</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson15.png">
                <p>通常のクラスより誘導や音楽を減らした静かなクラスです。ある程度マインドフルネス瞑想に慣れてきて、少ない誘導でも集中できる方におすすめのクラスです。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'

export default {
  name: 'Recommend07',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    }
  }
}
</script>
